import React from 'react';

interface ISpinnerProps {
    text: string;
}
const Spinner: React.FC<ISpinnerProps> = props => {
    const { text } = props;
    return (
        <div className='spinner-wrap'>
            <div className='preload-spinner-container'>
                <div className='preload-spinner' role='status'></div>
                <p>{text}</p>
            </div>
        </div>
    );
};

export default Spinner;
